import axiosInstance from "core/api/axiosInstance";

// ==================== SERVICIOS EXISTENTES ====================

export const postConciliation = async (comercio) => {
  try {
    const { data } = await axiosInstance.post(`/api/conciliation/get-data/${comercio}`, {});
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al obtener conciliaciones");
  }
};

export const getAllConciliation = async (filters = {}) => {
  try {
    const response = await axiosInstance.post(`/api/conciliation/get-all`, filters);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Error al obtener conciliaciones";
  }
};

export const getAllReports = async () => {
  try {
    const response = await axiosInstance.get(`/api/report/get-all`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al obtener reportes");
  }
};

export const updateReport = async (reportData) => {
  try {
    const response = await axiosInstance.put(`/api/report/update-report`, reportData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al actualizar reporte");
  }
};

// ==================== SERVICIOS PARA LOGS ====================

/**
 * Obtiene logs de correos enviados
 * @param {Object} params - Parámetros para filtrar los logs
 * @returns {Promise<Object>} - Resultado con los logs
 */
export const getReportLogs = async (params = {}) => {
  try {
    const defaultParams = {
      id: 1,
      name: "RejectedStep",
      ...params,
    };

    const response = await axiosInstance.post(`/api/report/get-log`, defaultParams);

    if (!response.data) {
      throw new Error("No se recibió respuesta del servidor");
    }

    if (response.data.code !== undefined && response.data.code !== 0) {
      throw new Error(response.data.message || `Error del servidor: código ${response.data.code}`);
    }

    return {
      success: true,
      data: response.data.data || [],
      rawResponse: response.data,
      message: response.data.message || "Logs obtenidos exitosamente",
      total: response.data.data?.length || 0,
      code: response.data.code,
    };
  } catch (error) {
    console.error("❌ Error en getReportLogs:", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
    });

    let errorMessage = "Error al obtener logs de correos";
    if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    }

    throw new Error(errorMessage);
  }
};

/**
 * Obtiene todos los logs organizados por comercio
 * @returns {Promise<Object>} - Objeto con logs agrupados por comercio
 */
export const getAllLogsByCommerce = async () => {
  try {
    const result = await getReportLogs({
      id: 1,
      name: "RejectedStep",
    });

    if (!result.success || !result.data) {
      return { success: false, data: {} };
    }

    const logsByCommerce = {};

    result.data.forEach((log) => {
      const commerce = log.metadata?.commerce;
      if (!commerce) return;

      if (!logsByCommerce[commerce]) {
        logsByCommerce[commerce] = {
          commerce,
          logs: [],
          totalLogs: 0,
          totalMessages: 0,
          lastLogDate: null,
        };
      }

      logsByCommerce[commerce].logs.push(log);
      logsByCommerce[commerce].totalLogs++;

      const messagesCount = log.metadata?.data?.messages?.length || 0;
      logsByCommerce[commerce].totalMessages += messagesCount;

      const logDate = log.createdAt;
      if (
        !logsByCommerce[commerce].lastLogDate ||
        new Date(logDate) > new Date(logsByCommerce[commerce].lastLogDate)
      ) {
        logsByCommerce[commerce].lastLogDate = logDate;
      }
    });

    return {
      success: true,
      data: logsByCommerce,
      total: result.data.length,
    };
  } catch (error) {
    console.error("Error obteniendo logs por comercio:", error);
    return { success: false, data: {} };
  }
};

/**
 * Versión simplificada que ya incluye los parámetros por defecto
 */
export const getRejectedStepLogs = async () => {
  return getReportLogs({
    id: 1,
    name: "RejectedStep",
  });
};

/**
 * Versión que permite filtrar por fechas
 * @param {Object} filters - Filtros adicionales
 */
export const getReportLogsWithDateRange = async (filters = {}) => {
  const params = {
    id: 1,
    name: "RejectedStep",
    ...filters,
  };
  return getReportLogs(params);
};
